import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularLoader, IconButton, Row, Typography } from 'seagull';
import { CloseCross, Text as TextIcon } from 'seagull/icons';
import { PromptBubble } from '../PromptBubble/PromptBubble';
import styles from './PdfAttachment.module.scss';
export const PdfAttachment = (param)=>{
    let { fileName, state, onRemove, removeAriaLabel, rootTestId, fileNameTestId, spinnerTestId, removeButtonTestId } = param;
    return /*#__PURE__*/ _jsx(PromptBubble, {
        testId: rootTestId,
        children: /*#__PURE__*/ _jsxs(Row, {
            gap: 8,
            alignItems: "center",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    skin: "secondary",
                    className: styles.icon,
                    children: /*#__PURE__*/ _jsx(TextIcon, {})
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    skin: state === 'submitted' ? 'standard' : 'secondary',
                    weight: "normal",
                    ellipsis: true,
                    testId: fileNameTestId,
                    children: fileName
                }),
                state === 'loading' && /*#__PURE__*/ _jsx(CircularLoader, {
                    size: 24,
                    testId: spinnerTestId
                }),
                state === 'loading-done' && onRemove != null && /*#__PURE__*/ _jsx(IconButton, {
                    bi: {
                        name: 'remove_pdf_attachment'
                    },
                    size: "small",
                    skin: "transparent",
                    onClick: onRemove,
                    "aria-label": removeAriaLabel,
                    testId: removeButtonTestId,
                    children: /*#__PURE__*/ _jsx(CloseCross, {
                        size: 14
                    })
                })
            ]
        })
    });
};
